export default __webpack_public_path__ + "static/hatAgo-f925305fedceddad9371fcca97aa63bf.png";